import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, DeviceFullDTO, SharedPlaylistDTO } from 'src/app/services/api/api';
import { SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'sb-page-device-details-playlists',
  templateUrl: './device-details-playlists.component.html',
  styleUrls: ['./device-details-playlists.component.scss'],
  standalone: false,
})
export class DeviceDetailsPlaylistsComponent implements OnInit {
  deviceId: number;
  device: DeviceFullDTO;

  playlistsloading: boolean = true;
  loading: boolean = true;

  sharedPlaylists: SharedPlaylistDTO[] = [];

  debounceTimer: ReturnType<typeof setTimeout> = null;

  // tslint:disable-next-line:variable-name
  _from?: SbLocalDateTime;
  get from(): SbLocalDateTime {
    return this._from;
  }

  set from(val) {
    this._from = val;
  }

  // tslint:disable-next-line:variable-name
  _till?: SbLocalDateTime;
  get till(): SbLocalDateTime {
    return this._till;
  }

  set till(val) {
    this._till = val;
  }

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .ss_nm_Device_retrieveFullById(this.deviceId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: DeviceFullDTO) => {
          this.device = e;
          this.playlistRequest();
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  playlistRequestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.playlistRequest();
    }, 500);
  }

  playlistRequest() {
    this.playlistsloading = true;
    const defaultTime: SbLocalDateTime = new SbLocalDateTime(DateTime.now());
    this.api
      .ss_nm_Network_retrieveAllSharedPlaylists({
        active: true,
        permitted: true,
        hasTemplateBookingPermittedScreenEntries: true,
        from: this.from ? this.from : defaultTime,
        till: this.till ? this.till : defaultTime,
        screen: null,
        device: this.device ? [Number(this.device.id)] : null,
        playerCull: null,
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.playlistsloading = false;
        })
      )
      .subscribe({
        next: (e: SharedPlaylistDTO[]) => {
          this.sharedPlaylists = e;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  handleDateChangeFrom(date: SbLocalDateTime) {
    this.from = date;
  }

  handleDateChangeTill(date: SbLocalDateTime) {
    this.till = date;
  }
}
